require("../../css/main.css");
require("./style.css");
import * as emailjs from "emailjs-com";

emailjs.init("BwoUWp8vZ0jznrbjn");

const button = document.getElementById("send-email");

// When the user clicks on send email
button.onclick = function () {
  const name = document.getElementById("contact-name");
  const email = document.getElementById("contact-email");
  const companyName = document.getElementById("contact-companyName");
  const phoneNumber = document.getElementById("contact-phoneNumber");
  const country = document.getElementById("contact-country");
  const interestedIn = document.getElementById("contact-interestedIn");
  const message = document.getElementById("contact-message");

  if (email.value && email.value !== "") {
    console.log(
      name.value,
      email.value,
      companyName.value,
      phoneNumber.value,
      country.value,
      interestedIn.value,
      message.value
    );

    const templateParams = {
      name: name.value,
      email: email.value,
      companyName: companyName.value,
      phoneNumber: phoneNumber.value,
      country: country.value,
      interestedIn: interestedIn.value,
      message: message.value,
    };

    emailjs.send("service_edbchrt", "template_gwfu35f", templateParams).then(
      () => {
        const sentEmailContainer = document.getElementById("sent-email");
        sentEmailContainer.setAttribute("style", "display: block!important");
        setTimeout(() => {
          sentEmailContainer.setAttribute("style", "display: none!important");
        }, 3000);
        email.value = "";
        message.value = "";
        companyName.value = "";
        phoneNumber.value = "";
        country.value = "";
        interestedIn.value = "";
        message.value = "";
      },
      (err) => {
        console.log("FAILED...", err);
      }
    );
  }
};
